/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LimitsInfoDTO } from './LimitsInfoDTO';
import type { UpgradeTierStepDTO } from './UpgradeTierStepDTO';

export type FinishUpgradeTierResponseDTO = {
    accountNumber?: string;
    generalProcessStatus?: FinishUpgradeTierResponseDTO.generalProcessStatus;
    limitsInfo?: LimitsInfoDTO;
    processId?: string;
    tierSteps?: Array<UpgradeTierStepDTO>;
    tierType?: FinishUpgradeTierResponseDTO.tierType;
};

export namespace FinishUpgradeTierResponseDTO {

    export enum generalProcessStatus {
        STARTED = 'STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DISCARDED = 'DISCARDED',
        BLOCKED = 'BLOCKED',
    }

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

